/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import moment from 'moment'
import { injectIntl } from 'react-intl'
import { ListItem } from 'material-ui'
import { List, ListItemText, Typography } from '@material-ui/core'

import * as constants from 'constants/Prestation'

class InformationPanel extends React.Component {

  getCriterias () {
    let criterias = []

    const qualifications = this.props.prestation.preferred_qualifications
    const skills = this.props.prestation.preferred_skills
    const nationalityOrigin = this.props.prestation.preferred_nationality_origin
    const sex = this.props.prestation.preferred_sex

    qualifications.forEach((qualification) => {
      criterias.push(qualification.intermedia_value)
    })

    skills.forEach((skill) => {
      criterias.push(skill.value)
    })

    if (nationalityOrigin &&
        nationalityOrigin.nationality) {
      criterias.push(nationalityOrigin.nationality)
    }

    if (sex) {
      criterias.push(sex.value)
    }

    return criterias.join(', ')
  }

	render () {
		const creationDate = moment(this.props.prestation.creation_time).format('DD.MM.YYYY HH:mm')
    const orderedDate = moment(this.props.prestation.ordered_start_time).format('DD.MM.YYYY')
    const orderedStartTime = moment(this.props.prestation.ordered_start_time).format('HH:mm')
    const orderedEndTime = moment(this.props.prestation.ordered_end_time).format('HH:mm')

    let orderedDateMessage = `Le ${orderedDate}, de ${orderedStartTime} à ${orderedEndTime}`
    if (this.props.prestation.invoice_only_additional_services) {
      orderedDateMessage = `Le ${orderedDate}`
    }

    const deliveredDate = moment(this.props.prestation.delivered_start_time).format('DD.MM.YYYY')
    const deliveredStartTime = moment(this.props.prestation.delivered_start_time).format('HH:mm')
    const deliveredEndTime = moment(this.props.prestation.delivered_end_time).format('HH:mm')

    let deliveredDateMessage = `Le ${deliveredDate}, de ${deliveredStartTime} à ${deliveredEndTime}`
    if (this.props.prestation.invoice_only_additional_services) {
      deliveredDateMessage = `Le ${deliveredDate}`
    }

		return (
      <ListItem
        primaryText={this.props.intl.formatMessage(constants.messages.DETAIL_MAIN_INFORMATION_LABEL)}
        initiallyOpen={false}
        primaryTogglesNestedList={true}
        nestedItems={[
          <List
            style={this.props.style}
            key={0}
          >
            <ListItemText
              disabled={true}
              primary={creationDate}
              secondary={this.props.intl.formatMessage(constants.messages.CREATION_DATE_TIME_LABEL)}
            />
          </List>,
          <List
            style={this.props.style}
            key={1}
          >
            <ListItemText
              disabled={true}
              primary={orderedDateMessage}
              secondary={this.props.intl.formatMessage(constants.messages.DETAIL_ORDERED_DATETIME_LABEL)}
            />
          </List>,
          <List
            style={
              this.props.prestation.invoice_only_additional_services
               ? this.props.style
               : {display: 'none'}
            }
            key={2}
          >
            <ListItemText
              disabled={true}
              primary={this.props.prestation.additional_services + ' ' + this.props.intl.formatMessage(constants.messages.MINUTES_LABEL)}
              secondary={this.props.intl.formatMessage(constants.messages.STEP_THREE_INVOICE_ONLY_ADDITIONAL_SERVICES_LABEL)}
            />
          </List>,
          <List
            style={
              this.props.prestation.delivered_start_time
               ? this.props.style
               : {display: 'none'}
            }
            key={3}
          >
            <ListItemText
              disabled={true}
              primary={deliveredDateMessage}
              secondary={this.props.intl.formatMessage(constants.messages.DETAIL_DELIVERED_DATETIME_LABEL)}
            />
          </List>,
          <List
            style={this.props.style}
            key={4}
          >
            <ListItemText
              disabled={true}
              primary={this.props.prestation.address.address}
              secondary={this.props.intl.formatMessage(constants.messages.DETAIL_LOCATION_LABEL)}
            />
          </List>,
          <List
            style={
              this.props.prestation.additional_address_line
               ? this.props.style
               : {display: 'none'}
            }
            key={5}
          >
            <ListItemText
              disabled={true}
              primary={
                <Typography style={styles.textStyle}>
                  {this.props.prestation.additional_address_line}
                </Typography>
              }
              secondary={this.props.intl.formatMessage(constants.messages.STEP_THREE_ADDITIONAL_ADDRESS_LINE)}
            />
          </List>,
          <List
            style={
              this.getCriterias() !== ''
               ? this.props.style
               : {display: 'none'}
            }
            key={6}
          >
            <ListItemText
              disabled={true}
              primary={this.getCriterias()}
              secondary={this.props.intl.formatMessage(constants.messages.DETAIL_CRITERIAS_LABEL)}
            />
          </List>
        ]}
      />
		)
	}
}

const styles = {
  textStyle: {
    marginRight: 5,
    fontSize: '16px',
    height: 'auto',
    overflow: 'visible',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
  }
}

export default injectIntl(InformationPanel)


// WEBPACK FOOTER //
// ./src/components/applicant/prestation/dashboard/InformationPanel.js